import React, { useState } from 'react';
import { Navbar } from '../layouts/Navbar';
import { Footer } from '../layouts/Footer';

export const ClinqUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        organization: '',
        message: ''
    });

    // Footer header content for clinq us page
    const footerHeader = ["Ready to Transform Your Clinic?", "Let's discuss how Clinqo can help you"];

    const handleSubmit = (e) => {
        e.preventDefault();
        // Add form submission logic here
        console.log('Form submitted:', formData);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            <div className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <br />
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Clinq With Us</h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Ready to revolutionize your healthcare practice? Connect with our team to discover how Clinqo can streamline your clinic operations and enhance patient experience.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                    {/* Contact Information */}
                    <div className="space-y-8">
                        <div>
                            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Get in Touch</h2>
                            <div className="space-y-6">
                                <div className="flex items-start space-x-4">
                                    <div className="flex-shrink-0">
                                        <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900">Our Office</h3>
                                        <p className="text-gray-600 mt-1">
                                            TI-109, 1st Floor, TIIR Building<br />
                                            Foundation for Technology and Business Incubation (FTBI)<br />
                                            National Institute of Technology<br />
                                            Rourkela, Odisha - 769008, India
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-4">
                                    <div className="flex-shrink-0">
                                        <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900">Email Us</h3>
                                        <p className="text-gray-600 mt-1">team@n6t.in</p>
                                        <p className="text-gray-600">support@clinqo.com</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-4">
                                    <div className="flex-shrink-0">
                                        <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                                            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-medium text-gray-900">Business Hours</h3>
                                        <p className="text-gray-600 mt-1">
                                            Monday - Friday: 9:00 AM - 6:00 PM<br />
                                            Saturday: 10:00 AM - 4:00 PM
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Why Choose Clinqo */}
                        <div className="bg-white rounded-lg p-6 shadow-md">
                            <h3 className="text-xl font-semibold text-gray-900 mb-4">Why Choose Clinqo?</h3>
                            <ul className="space-y-3 text-gray-600">
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-500 font-bold">•</span>
                                    <span>Reduce patient waiting times by up to 60%</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-500 font-bold">•</span>
                                    <span>WhatsApp integration for seamless communication</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-500 font-bold">•</span>
                                    <span>Real-time queue management and analytics</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-500 font-bold">•</span>
                                    <span>Easy integration with existing clinic systems</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-500 font-bold">•</span>
                                    <span>24/7 customer support and training</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="bg-white rounded-lg shadow-lg p-8">
                        <h2 className="text-2xl font-semibold text-gray-900 mb-6">Schedule a Demo</h2>
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                                    Full Name *
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Dr. John Smith"
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                    Email Address *
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="doctor@clinic.com"
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                                    Phone Number
                                </label>
                                <input
                                    type="tel"
                                    id="phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="+91 9876543210"
                                />
                            </div>

                            <div>
                                <label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-2">
                                    Clinic/Hospital Name *
                                </label>
                                <input
                                    type="text"
                                    id="organization"
                                    name="organization"
                                    value={formData.organization}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="City General Hospital"
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                                    Tell us about your needs
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="How many patients do you see daily? What challenges are you facing with queue management?"
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 font-medium"
                            >
                                Schedule Demo & Get Started
                            </button>
                        </form>

                        <p className="text-sm text-gray-500 mt-4 text-center">
                            Our team will contact you within 24 hours to schedule your personalized demo.
                        </p>
                    </div>
                </div>
            </div>
            <Footer header={footerHeader} />
        </div>
    );
};
